export const FirebaseConfig = {
	"projectId": "transport-caballos",
	"appId": "1:741955772758:web:1bb105ab0cb740121176f7",
	"databaseURL": "https://transport-caballos-default-rtdb.firebaseio.com",
	"storageBucket": "transport-caballos.appspot.com",
	"locationId": "us-central",
	"apiKey": "AIzaSyCQRuxmpT-l2iTbR8U_R53-1wZqXpNqQRI",
	"authDomain": "transport-caballos.firebaseapp.com",
	"messagingSenderId": "741955772758",
	"measurementId": "G-Z1SLHR1XD3",
	"projectNumber": "741955772758",
	"version": "2"
};